import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "",
};

export const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.value = action.payload;
    },
    removeToken: (state) => {
      state.value = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToken, removeToken } = tokenSlice.actions;

export default tokenSlice.reducer;
